import { Injectable } from '@angular/core';
import { Shippingtablerate } from 'src/app/models/shippingtablerate';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShippingTableRateService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + '/' + 'api/shippingtablerate';

  searchShippingTableRate(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }


  getShippingTableRate(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getShippingTableRateById(pk: number): Observable<Object> {
    return this.http.get(`${this.url}/${pk}`);
  }

  creategetShippingTableRate(page: Shippingtablerate): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, page)
  }

  downloadReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadShipingReportTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }


}